import React from "react"
import Layout from "../layouts/Layout"
import Header from "../components/Header"
import BenefitsCard from "../components/BenefitsCard"
import {container, heading,acmImage,benefits} from "../styles/about.module.css"


export default function About() {
  return (
    <Layout>
    <Header heading="ABOUT"></Header>
    <h1 className={heading}>About ACM</h1>
    
    <div className={container}>

    <section className="section about col1">
        
        <p className= "paragraph">The Association for Computing Machinery (ACM) is an international learned society for computing. It was founded in 1947 and is the world's largest scientific and educational computing society. 
        <br />

The ACM is a non-profit professional membership group which brings together computing educators, researchers, and professionals to inspire dialogue, share resources, and address the field's challenges. As the world’s largest computing society, ACM strengthens the profession's collective voice through strong leadership, promotion of the highest standards, and recognition of technical excellence. <br />

ACM supports the professional growth of its members by providing opportunities for life‐long learning, career development, and professional networking.</p>
      </section>
      <img className={acmImage} src="/acm.svg" alt="profile"/>
    </div>

      <div className="seperator"></div> 
    <section className="section about">
        <h1 className="heading">About ACM PCCOER</h1>
        <p className="paragraph">PCCOER ACM Student Chapter has been founded for the technical development of students in the field of computing. The Chapter provides a platform for students to showcase their talents. It facilitates community and individual growth in the computing profession.  The Chapter organizes a number of events, seminars, talks, and workshops for its members. It aims to promote Computer Science culture.</p>
      </section>
      <div className="seperator"></div> 
      
      <div className={benefits}>
      <h1 className={heading}>Benefits of ACM</h1>
      <BenefitsCard benefit = "Thousands of online books, courses and short videos from Skillsoft covering the most in-demand skills, software, and technologies for computing professionals"/>
      <BenefitsCard benefit = "More than 5,000 ebooks via Elsevier’s ScienceDirect platform, many from the respected Morgan Kaufmann and Syngress computer science imprints, all mobile optimized"/>
      <BenefitsCard benefit = "The option to subscribe to the full ACM Digital Library, which includes over 2 million pages of text"/>
      <BenefitsCard benefit = "Ability to search DL, access bibliographic citations, view article abstracts"/>
      <BenefitsCard benefit = "A full year (12 issues) online subscription to Communications of the ACM"/>
      <BenefitsCard benefit = "A full-year (4 issues) subscription to XRDS: Crossroads, ACM's Student Magazine"/>
      <BenefitsCard benefit = "A full-year electronic subscription to monthly MemberNet  newsletter"/>
      <BenefitsCard benefit = "Student Quick Takes (ACM's quarterly newsletters)"/>
      <BenefitsCard benefit = "TechNews (ACM's tri-weekly email IT news digest);"/>
      <BenefitsCard benefit = "CareerNews, ACM's twice monthly email career news digest"/>
      <BenefitsCard benefit = "Ubiquity, ACM's IT opinion magazine and forum, and eLearn, ACM's magazine dedicated to distance education"/>
      <BenefitsCard benefit = "Discounts on subscriptions to ACM journals, magazines, books, and conferences. Exclusive subscription pricing on ACM Books series. "/>
      <BenefitsCard benefit = "Special discounts and access to valuable products and services through the ACM's Insurance and Discounts and Special Offers programs"/>
      <BenefitsCard benefit = "Participation in ACM Distinguished Speakers Program (DSP)"/>

      </div>
      <div className="seperator"></div> 
      

    </Layout>
    

  )
}
